
<template>
  <div>
    <div class="find">
      <div class="seach-top">
        <el-form
          ref="searchForm"
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
        >
          <el-form-item
            label="关键字："
          >
            <el-input
              v-model="searchForm.keyWord"
              placeholder="请输入查询关键字"
              size="small"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="handleSearch"
            >
              查询
            </el-button>
          </el-form-item>
          <div
            class="btn-box"
            style="float: right;"
          />
        </el-form>
      </div>
    </div>

    <el-table
      class="table-list"
      :border="true"
      :data="tableData"
      style="width: 100%"
      @sort-change="handleResort"
    >
      <el-table-column label="邀请者" prop="applyName" width="120px" />
      <el-table-column label="受邀者" prop="applyName" width="120px" />
      <el-table-column label="单位" prop="danWeiMingCheng" width="120px" />
      <el-table-column label="部门" prop="buMen" width="150px" :show-overflow-tooltip="true" />
      <el-table-column label="科室" prop="keShi" width="150px" :show-overflow-tooltip="true" />
      <el-table-column label="邀请时间" prop="applyDateTimeShow" width="160px" />
      <el-table-column label="留言" prop="applyMessage" :show-overflow-tooltip="true" />
      <el-table-column
        fixed="right"
        label="操作"
        width="200"
      >
        <template slot-scope="scope">
          <el-button
            v-if="!scope.row.isFriend"
            type="text"
            size="small"
            @click="handleAgreedFriend(scope.row)"
          >
            同意
          </el-button>
          <span v-else>已添加</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next,total,sizes"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="10"
      :total="totalCount"
      @size-change="handleSizeChange"
      @current-change="handleChangePage"
    />
  </div>
</template>

<script>
import pathReq from '@/api/pathlist'
import KxjCom from '@/utils/kxjcom'
export default {
  components: {
  },
  filters: {
    dateFmt(val) {
      return KxjCom.tableDateFormat(val)
    },
    decFmt(val) {
      return KxjCom.tableDecFormat(val)
    }
  },
  props: {},
  data() {
    return {
      title: '邀请列表',
      totalCount: 0,
      tableData: [],
      allComboxData: [],
      searchForm: {
        keyWord: '',
        pageNumber: 1,
        pageSize: 10,
        sortKey: '',
        sortOrder: ''
      }
    }
  },
  computed: {},
  watch: {},
  activated() {},
  created() {
    this.$bus.on('FriendSearch3', this.handleSearch)
  },
  mounted() { },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    // 每页
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.handleSearch()
    },
    // 切页
    handleChangePage(page) {
      this.searchForm.pageNumber = page
      this.handleSearch()
    },
    // 排序
    handleResort(column) {
      this.searchForm.sortKey = column.prop
      this.searchForm.sortOrder = column.order
      this.handleSearch()
    },
    // 查询
    handleSearch() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      const path = '/api/services/app/Contact/GetPagedListContacts3'
      pathReq
        .getList(path, that.searchForm)
        .then(res => {
          loading.close()
          that.totalCount = res.data.result.totalCount
          that.tableData = res.data.result.items
        })
    },
    // 同意好友邀请
    handleAgreedFriend(row) {
      const that = this
      console.log(row)
      this.$confirm('确定要同意好友邀请吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const path = '/api/services/app/Contact/AgreedFriend'
        pathReq
          .postForm(path, {
            id: row.id
          })
          .then(res => {
            if (res.status === 200) {
              if (res.data.success) {
                this.$message.success('添加好友成功！')
                that.handleSearch()
                this.$bus.emit('FriendSearch2')
              } else {
                this.$message.error('添加好友失败！')
              }
            }
          })
      })
    }

  }
}
</script>

